import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';

import './FloatingActionButton.css';

export default class FloatingActionButton extends Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick();
    }

    render() {
        return (
            <div className="floating-action-button" onClick={this.handleClick}>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/FloatingActionButton.jsx